var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 84,
    viewBox: "0 0 86 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3543_43814)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.000244141 0V84H85.1725V0H-0.000244141ZM43.6787 6.58847C48.3509 6.58845 52.9773 7.50868 57.2939 9.29664C61.6104 11.0846 65.5325 13.7053 68.8363 17.009C72.14 20.3127 74.7607 24.2348 76.5486 28.5514C78.3366 32.8679 79.2568 37.4944 79.2568 42.1665C79.2567 51.6024 75.5083 60.6517 68.8361 67.3238C62.1639 73.9959 53.1146 77.7442 43.6787 77.7442C34.243 77.7441 25.1937 73.9958 18.5216 67.3237C11.8495 60.6516 8.10113 51.6023 8.10106 42.1665C8.10102 32.7307 11.8493 23.6813 18.5214 17.0091C25.1935 10.337 34.2429 6.58853 43.6787 6.58847Z",
    fill: "url(#paint0_radial_3543_43814)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5814 76.5721C62.5724 76.5721 77.9676 61.1769 77.9676 42.1858C77.9676 23.1948 62.5724 7.79956 43.5814 7.79956C24.5903 7.79956 9.19507 23.1948 9.19507 42.1858C9.19507 61.1769 24.5903 76.5721 43.5814 76.5721Z",
    stroke: "#11B0FF",
    strokeOpacity: 0.396078,
    strokeWidth: 2.21368
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4451 28.4557C53.4652 24.0336 57.4853 24.0336 61.5054 28.4557V56.7975C57.4853 60.8176 53.4652 60.8176 49.4451 56.7975V28.4557Z",
    fill: "#11B0FF",
    fillOpacity: 0.780392,
    stroke: "#3EACD9",
    strokeOpacity: 0.290196,
    strokeWidth: 1.08657,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2849 28.4557C31.305 24.0336 35.3251 24.0336 39.3452 28.4557V56.7975C35.3251 60.8176 31.305 60.8176 27.2849 56.7975V28.4557Z",
    fill: "#11B0FF",
    fillOpacity: 0.780392,
    stroke: "#3EACD9",
    strokeOpacity: 0.290196,
    strokeWidth: 1.08657,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3543_43814",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.5014 42.5695) rotate(-89.5241) scale(43.4089 42.3657)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11B0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11B0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3543_43814"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85.1728,
    height: 84,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.80f1c0f42fd100484d982426f691c7a0.svg";
export { ForwardRef as ReactComponent };